import React from 'react';
import { Navigate } from 'react-router-dom';
import { decryptData } from '../utils/encrypt';


function PrivateRoute({ children }) {
  const encrypted = localStorage.getItem('suyog_user');
  if (!encrypted) return <Navigate to="/login" />;

  try {
    const user = decryptData(encrypted);
    if (user?.user_id && user?.user_name) {
      return children;
    } else {
      return <Navigate to="/login" />;
    }
  } catch (err) {
    return <Navigate to="/login" />;
  }
}

export default PrivateRoute;
